// src/components/AutoRedirect.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const AutoRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("role");

    if (location.pathname === "/") {
      if (token && role === "admin") {
        navigate("/employer/dashboard");
      } else if (token && role === "candidate") {
        navigate("/");
      }
    }
  }, [location.pathname, navigate]);

  return null;
};

export default AutoRedirect;
